import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.fabricSqlEndpointMetadataLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.SqlEndpointLabel),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.SqlEndpointLabel)
    ]
})
export class FabricSqlEndpointMetadataLinkedService extends LinkedService { }